import React from 'react'

const NotAuthorize = () => {
  return (
    <div className="not-auth">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <h3 className="text-danger mb-0" style={{fontSize: 'medium'}}>Ups!, Not Authorize To View This</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotAuthorize
